module.exports = __webpack_public_path__ + "img/arrow-down.0959ea40.svg";